import React, { Component } from 'react';
import PropTypes from "prop-types";
import './style.css';
import './mobile.css';

class Paginator extends Component {
  constructor(props) {
    super(props);

    let buttons = [1];

    for (let i = 0; buttons.length < 5; i++) {
      if (buttons[buttons.length - 1] + 1 <= this.props.count) {
        buttons.push(buttons[buttons.length - 1] + 1);
        continue;
      }
      break;
    }

    this.state = {
      currentButtons: buttons
    }

    this.nextButtons = this.nextButtons.bind(this);
    this.previousButtons = this.previousButtons.bind(this);
  }

  render() {
    let currentButtons = this.state.currentButtons;

    let buttonsToShow = [];
    for (let i = 0; i < currentButtons.length; i++) {
      let buttonClass = this.props.activeButton === currentButtons[i] ? "pagination-button active" : "pagination-button";

      buttonsToShow.push(
        <div key={currentButtons[i]} className={buttonClass} onClick={() => { this.props.onClick(currentButtons[i]) }}>
          {currentButtons[i]}
        </div>
      );
    }

    return (
      <div className="mx-paginator">
        <div className="pagination">
          <div className="pagination-left" onClick={this.previousButtons}>
            <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24">
              <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
              <path d="M0-.5h24v24H0z" fill="none" />
            </svg>
          </div>
          <div className="pagination-buttons">
            {buttonsToShow}
          </div>
          <div className="pagination-right" onClick={this.nextButtons}>
            <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24">
              <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              <path d="M0-.25h24v24H0z" fill="none" />
            </svg>
          </div>
        </div>
      </div>
    );
  }

  nextButtons() {
    let currentButtons = this.state.currentButtons.slice();
    let futureButtons = [];

    let lastButton = currentButtons[currentButtons.length - 1];

    for (let i = 0; i < 5; i++) {
      if (lastButton + 1 > this.props.count) {
        break;
      } else {
        futureButtons.push(lastButton + 1)
        lastButton += 1;
      }
    }

    if (futureButtons.length > 0) {
      this.setState({
        currentButtons: futureButtons
      });
    }
  }

  previousButtons() {
    let currentButtons = this.state.currentButtons.slice();
    let futureButtons = [];

    let firstButton = currentButtons[0];

    if (firstButton === 1) { return; }

    for (let i = 5; i >= 1; i--) {
      futureButtons.push(firstButton - i);
    }


    if (futureButtons.length > 0) {
      this.setState({
        currentButtons: futureButtons
      });
    }
  }
}

Paginator.propTypes = {
  count: PropTypes.number.isRequired,
  activeButton: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
}

export default Paginator;



// WEBPACK FOOTER //
// ./src/components/paginator/index.js